import React from "react";
import {colors, Flex} from "../../ui";
import {Btns,BtnCardTab} from "./styles";

export const Btn = ({
                        disabled,
                        loading,
                        onClick,
                        children,
                        text,
                        className,
                        bg,
                        active,
                        hg,
                        align,
                        brdr,
                        classNameBtn,
                        style = {}
                    }) => {
    disabled = loading ? true : disabled;

    let theme = {
        color: bg ? ( disabled ? (loading ? "white" : "#999999") : colors.btn) : ( disabled ? (loading ? colors.btn : "#999999") : "white" ),
        bg: bg ? (disabled ? (loading ? "white" : "#f1f1f2") : "white") : (disabled ? (loading ? colors.btn : "#f1f1f2") : colors.btn ),
        loading : bg ? colors.btn : "white",
        bgHover : bg ? (disabled ? (loading ? "white" : "#f1f1f2") : "white" ) : (disabled ? (loading ? colors.btn : "#f1f1f2") : colors.btn),
        cursor : disabled ? ( loading ? "wait" :"not-allowed"): "pointer"
    };

    return (
        <Btns
            className={className}
            loading={theme.loading}
            bg={ theme.bg }
            active={active}
            hg={hg}
            alig={align}
            brdr={brdr}
            color={ theme.color }
            bgHover={theme.bgHover}
            shadow={disabled ? "0 1px 3px rgba(0,0,0,.15)" :"0 3px 8px rgba(0,0,0,.25)"}
            cursor = {theme.cursor}
            img = {disabled ? (loading ? "0" : ".5" ) : "1"}
        >
            <button
                className={classNameBtn}
                onClick={onClick}
                disabled={disabled}
                style={style}
            >
                {children}
            </button>
            {loading && (
                <Flex className="loading" direction={"column"}>
                    <div className="circle"> </div>
                </Flex>
            )}
        </Btns>
    );
};


export const BtnTab = ({
                           onClick,
                           disabled,
                           children,
                           text,
                           active,
                           flex = "0 0 auto",
                           className,
                           classNameBtn,
                       }) => {
    return (
        <BtnCardTab
            borde={active ? colors.btn : "transparent"}
            flex={flex}
            className={className}
        >
            <button onClick={onClick} className={classNameBtn} disabled={disabled}>
                {children ? children : text}
            </button>
        </BtnCardTab>
    );
};
